module.exports = __webpack_public_path__ + "img/news.2d738e80.png";